import { cn } from '@/lib/utils';

/**
 * Loyalty navigation icon. Colors via `currentColor` so the parent's text
 * color (and `transition-colors`) drives the active/inactive animation.
 *
 * The medal body (`.loyalty-medal`) is a single path: a circle with the star
 * punched out as a cutout. Because the circle is rotationally symmetric,
 * spinning the whole path around its centre leaves the circle looking static
 * while only the star-shaped hole appears to rotate. The two ribbon tails are
 * separate paths and stay put.
 *
 * @param active - When `true`, the star does a full 360° spin with overshoot
 *   (keyframes in `index.css`, keyed on the `data-active` attribute).
 */
export function LoyaltyIcon({ active, className, ...props }: React.SVGProps<SVGSVGElement> & { active?: boolean }) {
  return (
    <svg
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('nav-icon nav-icon--loyalty', className)}
      data-active={active ? 'true' : undefined}
      {...props}
    >
      <g clipPath="url(#clip0_loyalty)">
        <path
          className="loyalty-medal"
          d="M16.0276 3.90039C10.112 3.90039 5.31641 8.63854 5.31641 14.4838C5.31641 20.329 10.112 25.0672 16.0281 25.0672C21.9443 25.0672 26.7399 20.329 26.7399 14.4838C26.7399 8.63854 21.9437 3.90039 16.0276 3.90039ZM22.645 13.4891L20.0208 16.1232C19.8977 16.2465 19.8408 16.4198 19.867 16.5913L20.4232 20.2464C20.4899 20.687 20.0272 21.0197 19.6237 20.8206L16.2772 19.1686C16.1205 19.0912 15.9358 19.0912 15.7791 19.1686L12.4326 20.8206C12.0291 21.0197 11.5658 20.6876 11.6331 20.2464L12.1893 16.5913C12.2155 16.4204 12.1586 16.2465 12.0355 16.1232L9.41125 13.4891C9.09483 13.1713 9.27191 12.6333 9.71664 12.5604L13.4068 11.9535C13.5798 11.9248 13.729 11.8181 13.8097 11.6644L15.5341 8.38442C15.7419 7.9892 16.3144 7.9892 16.5228 8.38442L18.2471 11.6644C18.3278 11.8181 18.477 11.9248 18.6501 11.9535L22.3402 12.5604C22.785 12.6338 22.962 13.1719 22.6456 13.4891H22.645Z"
          fill="currentColor"
        />
        <path
          d="M18.0215 26.2256L20.1151 30.5645C20.3148 30.9781 20.8948 31.0177 21.1502 30.6351L22.9408 27.9517C23.0255 27.8249 23.1753 27.7555 23.328 27.7721L26.5363 28.1272C27.0124 28.18 27.3532 27.6844 27.1291 27.2668L24.7737 22.7695C24.7737 22.7695 22.4635 25.7535 18.0215 26.2262V26.2256Z"
          fill="currentColor"
        />
        <path
          d="M14.3773 26.1846L12.2837 30.5235C12.084 30.9371 11.504 30.9767 11.2485 30.5941L9.45802 27.9107C9.37325 27.7839 9.22346 27.7145 9.07077 27.7311L5.86247 28.0862C5.3864 28.139 5.04559 27.6433 5.2697 27.2257L7.62512 22.7285C7.62512 22.7285 9.93526 25.7125 14.3773 26.1852V26.1846Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_loyalty">
          <rect width="22" height="27" fill="white" transform="translate(5.19922 3.90039)" />
        </clipPath>
      </defs>
    </svg>
  );
}
